import { Dispatch, FC, SetStateAction } from 'react';
import styles from './BottomMenu.module.scss';
import clsx from 'clsx';
import { ReactComponent as PlayIcon } from 'images/new-icons/bottom-menu/play-icon-grey.svg';
import { ReactComponent as StarIcon } from 'images/new-icons/bottom-menu/start-icon-grey.svg';
import { ReactComponent as ShopIcon } from 'images/new-icons/bottom-menu/shop-icon-grey.svg';
import { ReactComponent as ProfileIcon } from 'images/new-icons/bottom-menu/profile-icon-grey.svg';

import { ReactComponent as PlayIconPrimary } from 'images/new-icons/bottom-menu/play-icon-primary.svg';
import { ReactComponent as StarIconPrimary } from 'images/new-icons/bottom-menu/star-icon-primary.svg';
import { ReactComponent as ShopIconPrimary } from 'images/new-icons/bottom-menu/shop-icon-primary.svg';
import { ReactComponent as ProfileIconPrimary } from 'images/new-icons/bottom-menu/profile-icon-primary.svg';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';

import useIsAuth from 'sdk/hooks/useIsAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type Props = {
  activeLink: string;
  setOpenProfileMenu: Dispatch<SetStateAction<boolean>>;
  openProfileMenu: boolean;
};

enum Links {
  FEED = '/feed',
  VENUES = '/venues',
  SHOP = '/shop',
  PROFILE = '/profile',
}

const BottomMenu: FC<Props> = ({ activeLink, openProfileMenu, setOpenProfileMenu }) => {
  const navigate = useNavigate();
  const { data: isAuthData } = useIsAuth();
  const isAuth = isAuthData?.isAuth;
  const location = useLocation();
  const { t } = useTranslation() as any;
  const { isShareOpened, isCommentsVisible } = useTypedSelector(state => state.postSlice);
  const { setIsSlideChange } = useActions();

  const isTransparentPage =
    location.pathname === Links.FEED
    || location.pathname === '/'
    || location.pathname.startsWith('/feed')
    || location.pathname.startsWith('/user/feed')
    || location.pathname.startsWith('/search/feed');

  const menuItems = [
    {
      link: Links.FEED,
      label: 'navbar.hightlights',
      Icon: activeLink === Links.FEED ? PlayIconPrimary : PlayIcon,
    },
    {
      link: Links.VENUES,
      label: 'navbar.venues',
      Icon: activeLink === Links.VENUES ? StarIconPrimary : StarIcon,
    },
    {
      link: Links.SHOP,
      label: 'navbar.shop',
      Icon: activeLink === Links.SHOP ? ShopIconPrimary : ShopIcon,
    },
    {
      link: Links.PROFILE,
      label: 'navbar.profile',
      Icon: activeLink === Links.PROFILE ? ProfileIconPrimary : ProfileIcon,
    },
  ];

  const handleMenuButton = (label: string, link: string) => {
    setIsSlideChange(false);

    if (label === 'navbar.profile') {
      if (isAuth) {
        navigate('/profile-menu');
      } else {
        navigate('/sign-up');
      }
    } else {
      navigate(link);
    }
  };

  return (
    <div
      className={clsx(styles.bottomMenu, isTransparentPage ? styles.bottomMenu__isTransparent : '')}
      style={{
        zIndex: isShareOpened || isCommentsVisible ? '-1' : 1,
      }}
    >
      {menuItems.map(({ link, label, Icon }) => (
        <div
          key={link}
          className={clsx(styles.bottomMenuItems, {
            [styles.active]: activeLink === link,
          })}
          onClick={() => handleMenuButton(label, link)}
        >
          <div className={clsx(styles.bottomMenuIcons)}>
            <Icon />
          </div>
          <p className={activeLink === link ? clsx(styles.active) : ''}>{t(label)}</p>
        </div>
      ))}
    </div>
  );
};

export default BottomMenu;
